import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './comliancyMessages';
import MenuItemWithSecurity from '@/shared/components/MenuItemWithSecurity';
import { functionalities, privileges } from '@/shared/services/AuthService';

const CompliancyGlobalActionsButton = props => {
  const {
    intl,
    disabled,
    onSendEmail,
    onMarkComplianceTypeAsInapplicable,
    onCreateRegistration,
    onUpdateTags,
  } = props;

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.RelationGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        <MenuItemWithSecurity
          functionality={functionalities.Relation}
          privilege={privileges.Update}
          id="compliance-overview-global-action-toggle-inapplicable"
          onSelect={onMarkComplianceTypeAsInapplicable}
        >
          {intl.formatMessage(messages.ToggleComplianceTypeApplicable)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          id="compliance-overview-global-action-send-email"
          functionality={functionalities.InteractionsOwn}
          privilege={privileges.Create}
          onSelect={onSendEmail}
        >
          {intl.formatMessage(messages.SendEmail)}
        </MenuItemWithSecurity>
         <MenuItemWithSecurity
          id="compliance-overview-global-action-new-registration"
          functionality={functionalities.RegistrationOwn}
          privilege={privileges.Create}
          onSelect={onCreateRegistration}
        >
          {intl.formatMessage(messages.NewRegistration)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          id="compliance-overview-global-action-add-remove-labels"
          functionality={functionalities.Relation}
          privilege={privileges.Update}
          onSelect={onUpdateTags}
        >
          {intl.formatMessage(messages.AddOrRemoveLabels)}
        </MenuItemWithSecurity>
      </DropdownButton>
    </span>
  );
};

CompliancyGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  onSendEmail: PropTypes.func.isRequired,
  onMarkComplianceTypeAsInapplicable: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onCreateRegistration: PropTypes.func.isRequired,
  onUpdateTags: PropTypes.func.isRequired,
};

CompliancyGlobalActionsButton.defaultProps = { disabled: false };

export default injectIntl(CompliancyGlobalActionsButton);
